<template>
    <div class="page-container">
        <Headbar>
            <template v-slot:left></template>
            <template v-slot:right>
                <Search class="search-desktop" :placeholder="$t('blinds.search_blinds')" @search="search"/>
                <button class="btn-search-mobile btn-icon-only"
                        @click="headbarExpanded = headbarExpanded === 'search' ? null : 'search'">
                    <font-awesome-icon v-if="headbarExpanded === 'search'" :icon="['far', 'times']"/>
                    <font-awesome-icon v-else :icon="['far', 'search']"/>
                </button>
            </template>
            <template v-slot:expanded>
                <div class="headbar-expanded-container">
                    <Search v-if="headbarExpanded === 'search'" :placeholder="$t('blinds.search_blinds')" @search="search"/>
                </div>
            </template>
        </Headbar>
        <main>
            <vue-good-table
                mode="remote"
                styleClass="vgt-table vgt-custom"
                :columns="columns"
                :rows="blinds"
                :isLoading.sync="is_loading_blinds"
                :search-options="{
                    enabled: false,
                }"
                :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    dropdownAllowAll: false,
                    perPage: 15,
                    perPageDropdownEnabled: false,
                    rowsPerPageLabel: $t('x_per_page', {x: $t('blinds.blinds')}),
                }"
                :sort-options="{
                    enabled: true,
                    multipleColumns: true,
                }"
                :totalRows="totalRecords"
                @on-page-change="onPageChange">
                <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field === 'after'" class="td-after">
                        <router-link :to="{name: 'blinds-update', params: {id: props.row.id}}" v-if="$store.getters.hasPermission('update blinds')">
                            <Button className="--secondary --outline --mini --big-text">
                                <font-awesome-icon :icon="['fal', 'pencil']"/>
                            </Button>
                        </router-link>
                    </div>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
            </vue-good-table>
        </main>
    </div>
</template>

<script>
import Headbar from "../../components/headbar/Headbar";
import Search from "../../components/Search";
import Button from "../../components/Button";
import Select from "../../components/form/Select";
import ConfirmModal from "../../components/modal/ConfirmModal";

export default {
    name: "articles-index-page",
    components: {ConfirmModal, Select, Button, Search, Headbar},
    data: function () {
        const columns = [
            {
                label: this.$t('blinds.name'),
                field: 'attributes.name',
                sortable: false,
            },
            {
                label: this.$t('blinds.type'),
                field: this.typeFn,
                sortable: false,
            },
        ];

        if (this.$store.getters.hasAnyPermission(['update blinds']))
            columns.push({
                label: this.$t('articles.actions'),
                field: 'after',
                tdClass: 'td-after',
                sortable: false
            });

        return {
            columns: columns,
            blinds: [],
            is_loading_blinds: false,
            totalRecords: null,
            serverParams: {sorting: [], sort_by: 'created_at', sort_order: 'asc'},
            searchTerm: null,
            headbarExpanded: false
        }
    },
    methods: {
        typeFn(row) {
            if (row.attributes.type === 'zebra_blind')
                return 'Zebra Blind';
            else if (row.attributes.type === 'zebra_blind_2')
              return 'Zebra Blind 2';
            else if (row.attributes.type === 'roller_blind_1')
                return 'Roller Blind 1';
            else if (row.attributes.type === 'roller_blind_2')
                return 'Roller Blind 2';
            else if (row.attributes.type === 'roller_blind_3')
                return 'Roller Blind 3';
            else if (row.attributes.type === 'curtain_blind')
                return 'Curtain Blind Small';
            else if (row.attributes.type === 'curtain_blind_2')
              return 'Curtain Blind Large';
            else if (row.attributes.type === 'vertical_90mm')
                return 'Vertical 90mm';
            else if (row.attributes.type === 'vertical_127mm')
                return 'Vertical 127mm';
            else if (row.attributes.type === 'venetian_blind')
                return 'Venetian Blind';
            else if (row.attributes.type === 'pvc_pelmet_cover')
                return 'PVC Pelmet Cover';
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.retrieveBlinds();
        },
        removeParam(param) {
            this.$delete(this.serverParams, param);
        },
        search(searchTerm) {
            this.searchTerm = searchTerm;

            if (searchTerm && searchTerm.length) {
                this.updateParams({term: searchTerm});
            } else this.removeParam('term');

            this.retrieveBlinds();
        },
        retrieveBlinds() {
            this.is_loading_blinds = true;

            this.$axios.get('blinds', {params: {...this.serverParams}})
                .then(({data}) => {
                    this.blinds = data.data;
                    this.totalRecords = data.meta.total;
                    this.is_loading_blinds = false;
                })
                .catch(e => {
                    this.is_loading_blinds = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data, this.$t('blinds.error_retrieve')),
                        type: 'error',
                    });
                });
        },
    },

    mounted() {
        if (this.$store.getters.hasRole('agent'))
            this.$router.push({name: 'calculators-index'});
        this.retrieveBlinds();
    },
    head() {
        return {
            title: {
                inner: this.$t('nav.blinds')
            },
        }
    }
}
</script>

<style lang="scss" scoped>
    .page-container {
        .headbar-expanded-container {
            @apply mt-4 flex flex-col gap-y-4 items-center;

            @screen md {
                @apply hidden;
            }
        }

        .select-dropdown {
            @apply min-w-40;
        }

        .btn-search-mobile, .btn-filter-mobile {
            @apply block text-primary w-6;

            @screen md {
                @apply hidden;
            }

            &:active, &:focus {
                @apply outline-none;
            }
        }

        .search-desktop, .filter-desktop {
            @apply hidden;

            @screen md {
                @apply block;
            }
        }

        .search-container {
            @apply mr-0;
        }

        .filter-mobile {
            @apply max-w-xs;
        }

        .td-after {
            @apply flex flex-row;

            & > * {
                @apply mx-auto;
            }
        }
    }
</style>
